<script>
  import Bicycle from "./svg/icons/Bicycle.svelte";
  import ShareIcon from "./svg/icons/files/ShareIcon.svelte";
  import { appManager } from "./AppManagerStore";
  import { _ } from "svelte-i18n";
    import RightCircle from "./svg/icons/code/RightCircle.svelte";
</script>

<section id="why" class="py-8 py-md-11">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-12 col-md-6 col-lg-5 order-md-2">
        <div class="d-flex flex-column w-md-130 mb-6 mb-md-0">
            <img
                class="img-fluid rounded shadow align-self-start"
                data-jarallax-element="-20"
                src="img/screenshots/ui/impact-2.png"
                alt="..."
                style="min-height: 1px; max-width: 50%; margin-left: 40%;" />

            <img
                class="img-fluid rounded shadow align-self-start"
                data-jarallax-element="-50"
                src="img/screenshots/ui/impact-1.png"
                alt="..."
                style="min-height: 1px; max-width: 50%; margin-top: -35%;" />

            <img
                class=" img-fluid rounded shadow align-self-center"
                data-jarallax-element="-80"
                src="img/screenshots/apps/diff-wechelderzande.png"
                alt="..."
                style="min-height: 1px; max-width: 50%; margin-top: -20%;" />
        </div>
    </div>
      <div class="col-12 col-md-7 col-lg-6 order-md-1">
         <span class="badge rounded-pill bg-primary-soft mb-1">
          <span class="h6 text-uppercase">{$_("why.tag")}</span>
        </span>
        <h1>{$_("why.title.part1")}<br><span class="text-primary">{$_("why.title.part2")}</span></h1>

        <p class="fs-lg text-muted mb-2">
          {$_("why.content.part1")}
        </p>

        <p class="fs-lg text-muted mb-2">
          {$_("why.content.part2")}
          
        </p>

        <div class="d-flex h-86px m-1 mt-5" >
          <div class="icon text-primary">
            <RightCircle />
          </div>

          <div class="ms-5">
            <h4 class="mb-1">{$_("why.bullet1.title")}</h4>

            <p class="text-muted mb-5">
              {$_("why.bullet1.content")}
            </p>
          </div>
        </div>

        <div class="d-flex h-86px m-1">
          <div class="icon text-primary">
            <RightCircle />
          </div>

          <div class="ms-5">
            <h4 class="mb-1">{$_("why.bullet2.title")}</h4>

            <p class="text-muted mb-5">
              {$_("why.bullet2.content")}
            </p>
          </div>
        </div>

        <div class="d-flex h-86px m-1">
          <div class="icon text-primary">
            <RightCircle />
          </div>

          <div class="ms-5 ">
            <h4 class="mb-1">{$_("why.bullet3.title")}</h4>

            <p class="text-muted mb-5">
              {$_("why.bullet3.content")}
            </p>
          </div>
        </div>

        <div class="d-flex h-86px m-1">
          <div class="icon text-primary">
            <RightCircle />
          </div>

          <div class="ms-5">
            <h4 class="mb-1">{$_("why.bullet4.title")}</h4>

            <p class="text-muted mb-5">
              {$_("why.bullet4.content")}
            </p>
          </div>
        </div>

        <p class="fs-lg text-muted mb-6">
          {$_("why.cta.part1")}
          <a href="{$appManager.PublicUrl}contact"
            >{$_("why.cta.part2")}</a
          >.
        </p>

        <p class="">
          <a
            class="btn btn-primary shadow lift"
            href="{$appManager.PublicUrl}contact">
            {$_("general.contactus")}
            <i class="fe fe-arrow-right ms-3" />
          </a>
        </p>
      </div>
    </div>
  </div>
</section>

<style>
  .h-86px {
    height: 86px;
  }
</style>